if (!customElements.get('product-ingredients-drawer')) {
  customElements.define('product-ingredients-drawer', class ProductIngredientsDrawer extends HTMLElement {
    constructor() {
      super();

      this.overlay = document.getElementById('CartDrawer-Overlay');
      this.closeButton = this.querySelector('.drawer__close');

      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.hide());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.hide());
      }


      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
    }


    hide() {
      console.log('Hiding drawer'); // Debugging
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');

      document.dispatchEvent(new CustomEvent('openBar'));
    }

    show() {
      console.log('Showing drawer'); // Debugging
      this.classList.add('active');

      if(document.querySelector('.header-wrapper.header-fixed')) {
        const t = document.querySelector('.header-wrapper.header-fixed').clientHeight;
        this.style.top = `${t}px`;
      }

      document.body.classList.add('overflow-hidden');

      document.dispatchEvent(new CustomEvent('closeBar'));
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const triggerButton = document.querySelector('.product-ingredients-trigger');
  const drawer = document.querySelector('product-ingredients-drawer');

  if (!triggerButton) {
    console.error('Trigger button not found');
    return;
  }

  if (!drawer) {
    console.error('Drawer element not found');
    return;
  }

  triggerButton.addEventListener('click', () => {
    console.log('Button clicked, attempting to show drawer'); // Debugging
    drawer.show();
  });
});
